import React from 'react';
import { FormRenderProps } from 'react-final-form';

import { useAppLayoutContextConsumer, Card, CardContent } from '@occc-app/design-system';
import { FormContent } from '@occc-app/routes/Campaign/components/FormContent';
import { getCampaignCreatePageHeaderLinks } from '@occc-app/routes/Campaign/utils';
import { CampaignFormValues } from '@occc-app/routes/Campaign/types';

interface ICreateCampaignFormRenderComponentProps
  extends Pick<FormRenderProps<CampaignFormValues>, 'handleSubmit'> {
  name: string;
}

export const CreateCampaignFormRenderComponent: React.FC<
  ICreateCampaignFormRenderComponentProps
> = ({ handleSubmit, name }) => {
  const links = React.useMemo(() => getCampaignCreatePageHeaderLinks(name), [name]);

  useAppLayoutContextConsumer(links);

  return (
    <form onSubmit={handleSubmit} data-testid='campaign-create-form'>
      <Card>
        <CardContent>
          <FormContent />
        </CardContent>
      </Card>
    </form>
  );
};
